import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { Link } from 'foundations-components/transitional/components/Link';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { GenerateChartIcon } from 'foundations-assets/icons/components/GenerateChartIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompareBulkActionComparisonDisallowed = props => {
  const {
    openUpgradeModal
  } = useUpgradeModal('forms-comparison-tool');
  const formIds = props.selectedObjects.map(crmObject => getPropertyValue(crmObject, PROPERTIES.FORM_ID));
  const disabled = formIds.length > 10;
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !disabled,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.table.tableActions.compareTooltip.title"
    }),
    children: /*#__PURE__*/_jsxs(Link, {
      disabled: disabled,
      onClick: openUpgradeModal,
      "data-action": "bulk-compare",
      children: [/*#__PURE__*/_jsx(GenerateChartIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.table.tableActions.compareForms"
      }), /*#__PURE__*/_jsx(LockBadge, {})]
    })
  });
};
export default CompareBulkActionComparisonDisallowed;